export enum ScannerType {
  REGULA = "REGULA",
  MICROBLINK_NEW = "MICROBLINK_NEW",
  MICROBLINK_BLINKID = "MICROBLINK_BLINKID",
  INCODE = "INCODE",
}

export enum ScannerInstanceType {
  REGULA = "REGULA",
  INCODE = "INCODE",
}
